export function ShareBaseAppInterceptor() {
	return {
		'request': function (config) {
			config.headers['x-sharebase-app'] = 'WEB';
			return config;
		}
	};
}



// WEBPACK FOOTER //
// ./src/sharebase-app/interceptors/xSharebaseAppInterceptor.ts